export function classes(...cls: (string | boolean | undefined)[]) {
  return cls.filter((c) => !!c).join(' ');
}
